module.exports = __webpack_public_path__ + "img/重庆敏德兴.e72fd2fe.jpg";